<div class="media-duration" *ngIf="media.duration">
    {{media.duration}}
</div>
<div class="media-progress">
    <app-progress-bar [barHeight]="6" [progress]="progress" [max]="100"
                      [class.d-none]="!progress"></app-progress-bar>
</div>
<div class="image-wrapper show-details-thumb">
    <div>
        <picture>
            <source *ngIf="this.media && this.media.image" srcset="{{this.media.image + '?width=250'}}">
            <img class="thumb-image h-100 w-100" src="{{config.remoteConfig.loading_packshot}}"
                 alt="Loading Image"/>
        </picture>
    </div>
</div>
